<template>
  <div class="login block">
    <div class="login__header" :class="{'hidden': hiddenHeader}">
      <div class="block-wrapper">
        <div class="login__header-wrapper">
          <div class="login__time">
            <Time/>
          </div>
        </div>
      </div>
    </div>
    <div class="login__wrapper block-wrapper">
      <div class="login__content">
        <div class="login__logo">
          <LogoDevelop/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  // components
  import Time from '@/components/times/Time'
  import LogoDevelop from '@/components/logos/LogoDevelop'
  import TimerController from '@/app/timer/timer-controller'
  import AuthController from '@/components/auth/auth-controller'
  import { mapState } from 'vuex'

  export default {
    mixins: [TimerController, AuthController],
    components: {
      Time,
      LogoDevelop
    },
    computed: {
      ...mapState({
        hideHeader: state => state.gui.header
      }),
      hiddenHeader () {
        return this.hideHeader
      }
    },
    watch: {
      '$route' () {
        this.autoAuth(
            this.$route?.query?.id,
            this.$route?.query?.key,
            this.$route?.query?.viewport_width,
            this.$route?.query?.viewport_initial_scale,
            this.$route?.query?.shrink_to_fit
        )
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm =>
          vm.autoAuth(
              to.query?.id,
              to.query?.key,
              to.query?.viewport_width,
              to.query?.viewport_initial_scale,
              to.query?.shrink_to_fit
          )
      )
    },
    mounted () {
      this.offTimer()
    }
  }
</script>
